import { useState } from 'react';

/**
 * @function
 * @name useShiftSelected
 * @param itemsIds - all page items for check
 * @param servicesChecked - checked state
 * @description Checkboxes select hook with shift
 * @returns {func}
 */
export default (itemsIds, servicesChecked) => {
  const [lastSelectedItem, setLastSelectedItem] = useState(null);

  const getNewSelectedItems = (value) => {
    const currentSelectedIndex = itemsIds.findIndex((item) => item === value);
    const lastSelectedIndex = itemsIds.findIndex((item) => item === lastSelectedItem);

    if (lastSelectedIndex === -1) {
      return [value];
    }
    return itemsIds
      .slice(Math.min(lastSelectedIndex, currentSelectedIndex), Math.max(lastSelectedIndex, currentSelectedIndex) + 1)
      .map((item) => item);
  };

  const onChange = (event, value) => {
    const hasBeenSelected = !servicesChecked.includes(value);
    setLastSelectedItem(value);

    if (event.nativeEvent.shiftKey) {
      const newSelectedItems = getNewSelectedItems(value);
      const selections = [...new Set([...servicesChecked, ...newSelectedItems])];

      if (!hasBeenSelected) {
        return selections.filter((item) => !newSelectedItems.includes(item));
      }

      return selections;
    }

    return servicesChecked.includes(value) ? servicesChecked.filter((item) => item !== value) : [...servicesChecked, value];
  };

  return onChange;
};
